export const CE_DOCUMENT_VALIDATE = {
  localhost:'https://ce-dap-new-client-web.clsales.ist-ia9.npe-k8s.chl.bns/v1/dapntb/document-validate',
  ist: 'https://ce-dap-new-client-web.clsales.ist-ia9.npe-k8s.chl.bns/v1/dapntb/document-validate',
  uat: 'https://ce-dap-new-client-web.clsales.ist-ia9.npe-k8s.chl.bns/v1/dapntb/document-validate',
  prod: 'https://banco.scotiabank.cl/clsales/ce-dap-new-client-web/v1/dapntb/document-validate'
}
export const CE_ACCEPTANCE_TEXT = {
  localhost:'https://ce-dap-new-client-web.clsales.ist-ia9.npe-k8s.chl.bns/v1/dapntb/consent/acceptance-text',
  ist: 'https://ce-dap-new-client-web.clsales.ist-ia9.npe-k8s.chl.bns/v1/dapntb/consent/acceptance-text',
  uat: 'https://ce-dap-new-client-web.clsales.ist-ia9.npe-k8s.chl.bns/v1/dapntb/consent/acceptance-text',
  prod: 'https://banco.scotiabank.cl/clsales/ce-dap-new-client-web/v1/dapntb/consent/acceptance-text'
}
export const CE_CONSENT = {
  localhost:'https://ce-dap-new-client-web.clsales.ist-ia9.npe-k8s.chl.bns/v1/dapntb/consent/sign',
  ist: 'https://ce-dap-new-client-web.clsales.ist-ia9.npe-k8s.chl.bns/v1/dapntb/consent/sign',
  uat: 'https://ce-dap-new-client-web.clsales.ist-ia9.npe-k8s.chl.bns/v1/dapntb/consent/sign',
  prod: 'https://banco.scotiabank.cl/clsales/ce-dap-new-client-web/v1/dapntb/consent/sign'
}

export const CE_PRODUCTS = {
  localhost:'https://ce-dap-new-client-web.clsales.ist-ia9.npe-k8s.chl.bns/v1/dapntb/products',
  ist: 'https://ce-dap-new-client-web.clsales.ist-ia9.npe-k8s.chl.bns/v1/dapntb/products',
  uat: 'https://ce-dap-new-client-web.clsales.ist-ia9.npe-k8s.chl.bns/v1/dapntb/products',
  prod: 'https://banco.scotiabank.cl/clsales/ce-dap-new-client-web/v1/dapntb/products'
}

export const CE_SIMULATE = {
  localhost:
    'https://ce-dap-new-client-web.clsales.ist-ia9.npe-k8s.chl.bns/v1/dapntb/simulate',
  ist: 'https://ce-dap-new-client-web.clsales.ist-ia9.npe-k8s.chl.bns/v1/dapntb/simulate',
  uat: 'https://ce-dap-new-client-web.clsales.ist-ia9.npe-k8s.chl.bns/v1/dapntb/simulate',
  prod: 'https://banco.scotiabank.cl/clsales/ce-dap-new-client-web/v1/dapntb/simulate'
}

export const CE_CONTRACT = {
  localhost:
    'https://ce-dap-new-client-web.clsales.ist-ia9.npe-k8s.chl.bns/v1/dapntb/contract',
  ist: 'https://ce-dap-new-client-web.clsales.ist-ia9.npe-k8s.chl.bns/v1/dapntb/contract',
  uat: 'https://ce-dap-new-client-web.clsales.ist-ia9.npe-k8s.chl.bns/v1/dapntb/contract',
  prod: 'https://banco.scotiabank.cl/clsales/ce-dap-new-client-web/v1/dapntb/contract'
}

export const CE_EVERTEC = {
  localhost:
    'https://ce-dap-new-client-web.clsales.ist-ia9.npe-k8s.chl.bns/v1/dapntb/evertec-response',
  ist: 'https://ce-dap-new-client-web.clsales.ist-ia9.npe-k8s.chl.bns/v1/dapntb/evertec-response',
  uat: 'https://ce-dap-new-client-web.clsales.ist-ia9.npe-k8s.chl.bns/v1/dapntb/evertec-response',
  prod: 'https://banco.scotiabank.cl/clsales/ce-dap-new-client-web/v1/dapntb/evertec-response'
}

export const CE_DASHBOARD = {
  localhost:
    '/clsales/ce-dap-new-client-web/v1/dapntb/dashboard',
  ist: '/clsales/ce-dap-new-client-web/v1/dapntb/dashboard',
  uat: '/clsales/ce-dap-new-client-web/v1/dapntb/dashboard',
  prod: 'https://banco.scotiabank.cl/clsales/ce-dap-new-client-web/v1/dapntb/dashboard'
}
export const ROUTE_ONBOARDING = {
  localhost:
    'https://banco.ist-ia9.npe-k8s.chl.bns/mfe/clsales/mfe-onboarding-unico-wpub',
  ist: 'https://banco.ist-ia9.npe-k8s.chl.bns/mfe/clsales/mfe-onboarding-unico-wpub',
  uat: 'https://banco.ist-ia9.npe-k8s.chl.bns/mfe/clsales/mfe-onboarding-unico-wpub',
  prod: 'https://banco.scotiabank.cl/mfe/clsales/mfe-onboarding-unico-wpub'
}

export const ROUTE_DAP = {
  localhost:'http://localhost:3000/',
  ist: 'https://banco.ist-ia9.npe-k8s.chl.bns/mfe/clsales/mfe-dap-new-client-web-cl/',
  uat: 'https://banco.ist-ia9.npe-k8s.chl.bns/mfe/clsales/mfe-dap-new-client-web-cl/',
  prod: 'https://banco.scotiabank.cl/mfe/clsales/mfe-dap-new-client-web-cl/'
}